export default __webpack_public_path__ + "static/media/Sarah-Ryan.2c4966ef.png";